<template>
  <div class="ptos">
    <page-heading title="My PTOs">
      <template slot="buttons">
        <el-button @click="openFormModal" type="info">Request Time-Off</el-button>
      </template>
    </page-heading>

    <content-placeholder v-if="fetching">
      <el-card>
        <p class="text text-10 text-h-20"></p>
        <p class="text text-full"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-25"></p>
      </el-card>
    </content-placeholder>

    <div v-else-if="currentUser">
      <el-card>
        <div slot="header">
          <span>Status</span>
        </div>
          <div>Remaining Vacation/PTO Days: {{ currentUser.remaining_pto_days }}</div>
          <div>Remaining Sickness/Wellness Days: {{ currentUser.remaining_sickness_days }}</div>
      </el-card>
      <el-card>
        <div slot="header">
          <span>Pending PTOs [{{ pendingPtos.length }}]</span>
        </div>
        <ptos-list
          :ptos="pendingPtos"
          :user_id="currentUser.id"
          :default-sort="{ prop: 'starts_at', order: 'ascending' }"
          :showPendingEdit="true"
          :onEditPto="handleEditPendingPto">
        </ptos-list>
      </el-card>

      <el-card>
        <el-tabs v-model="activeName">
          <el-tab-pane :label="`Rejected PTOs [`+ rejectedPtos.length +`]`" name="second">
            <ptos-list :ptos="rejectedPtos" :user_id="currentUser.id"></ptos-list>
          </el-tab-pane>
          <el-tab-pane :label="`Approved PTOs [`+ approvedPtos.length +`]`" name="third">
            <ptos-list :ptos="approvedPtos" :user_id="currentUser.id"></ptos-list>
          </el-tab-pane>
        </el-tabs>
      </el-card>

      <pto-form-modal />
    </div>

    <content-placeholder v-else>
      <el-card>
        <p class="text text-10 text-h-20"></p>
        <p class="text text-full"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-25"></p>
      </el-card>
    </content-placeholder>

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import PtosList from '@/components/pto/PtosList';
  import PtoFormModal from '@/components/pto/PtoFormModal';

  export default {
    name: 'PtosPage',
    components: {
      ptoFormModal: PtoFormModal,
      ptosList: PtosList,
    },
    data() {
      return {
        activeName: 'third',
        translationPrefix: 'pages.ptoRequests',
      };
    },
    created() {
      this.fetchMyPtos();
    },
    computed: {
      ...mapGetters('entities/ptos', ['fetching']),
      ...mapGetters('entities/users', ['currentUser']),

      pendingPtos() {
        if (!this.currentUser || !this.currentUser.id) {
          return [];
        }

        return this.$store.getters['entities/ptos/query']()
          .with('category')
          .with('user.profile')
          .where('status', 'pending')
          .where('user_id', this.currentUser.id)
          .get();
      },

      rejectedPtos() {
        if (!this.currentUser || !this.currentUser.id) {
          return [];
        }

        return this.$store.getters['entities/ptos/query']()
          .with('user.profile')
          .with('category')
          .where('status', 'rejected')
          .where('user_id', this.currentUser.id)
          .get();
      },

      approvedPtos() {
        if (!this.currentUser || !this.currentUser.id) {
          return [];
        }

        return this.$store.getters['entities/ptos/query']()
          .with('user.profile')
          .with('category')
          .where('status', 'approved')
          .where('user_id', this.currentUser.id)
          .get();
      },
    },
    watch: {
      currentUser(newVal, oldVal) {
        // Refetch PTOs when user logs in (oldVal is null, newVal has id)
        if (newVal && newVal.id && (!oldVal || !oldVal.id)) {
          this.fetchMyPtos();
        }
      },
    },
    methods: {
      ...mapActions('entities/ptos', ['fetchPtos', 'openFormModal', 'setContext']),
      handleEditPendingPto(pto) {
        if (!pto || pto.status !== 'pending' || !this.currentUser || pto.user_id !== this.currentUser.id) {
          this.$message({ type: 'error', message: 'You can only edit your own pending PTO requests.' });
          return;
        }

        this.setContext(pto.id);
        this.openFormModal();
      },
      fetchMyPtos() {
        return this.fetchPtos({
          myptos: true,
          page: 1,
          per_page: 200,
          order: 'desc',
        });
      },
    },
  };
</script>

<style lang="scss">
  .el-tabs__content{
    overflow: visible;
  }
</style>



// WEBPACK FOOTER //
// src/pages/MyPtos.vue